// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile_wrapper__qcw8b","profileName":"Profile_profileName__gL4w7"};